import { Button } from "plos/src/components/buttons/Button";
import Link from "plos/src/components/links/Link/Link";
import { Sheet } from "plos/src/components/Sheet";
import { useTranslation } from "react-i18next";
import { whatsNewContainer, whatsNewList } from "./whatsNewSheet.css";

interface WhatsNewSheetProps {
  isOpen: boolean;
  onClose: () => void;
}

const WhatsNewSheet = ({ isOpen, onClose }: WhatsNewSheetProps) => {
  const { t } = useTranslation("pickTeam");

  return (
    <Sheet
      open={isOpen}
      handleClose={onClose}
      title={t("whatsNew.whatsNew", "What's New")}
      footer={
        <Button onPress={onClose} fullWidth>
          {t("whatsNew.close", "Close")}
        </Button>
      }
    >
      <div className={whatsNewContainer}>
        <p>
          {t(
            "whatsNew.welcomeMessage",
            "Here’s what's changed for the 26/27 season...",
          )}
        </p>
        <ul className={whatsNewList}>
          <li>
            <strong>
              {t("whatsNew.realTimePointsAndRanks", "Real-time ranks")}
            </strong>{" "}
            -{" "}
            {t(
              "whatsNew.realTimePointsAndRanksDescription",
              "Your overall rank and league positions now update live during a Gameweek. This includes provisional bonus points once a match has been played for 20 minutes.",
            )}{" "}
          </li>
          <li>
            <strong>
              {t("whatsNew.priceChangeIndicators", "Price change predictions")}
            </strong>{" "}
            -{" "}
            {t(
              "whatsNew.priceChangeIndicatorsDescription",
              "Player prices now change daily at midnight UK time. A new page shows how close each player is to a price rise or fall ahead of the next price change deadline.",
            )}{" "}
          </li>
          <li>
            <strong>
              {t(
                "whatsNew.onboardingAndTutorials",
                "Autopick tutorial and help pages",
              )}
            </strong>{" "}
            -{" "}
            {t(
              "whatsNew.onboardingAndTutorialsDescription",
              "New managers can follow a guided tutorial when building their first squad, while all managers can use the improved Autopick to help create a solid starting team. New help pages also provide additional guidance for first-time managers.",
            )}{" "}
          </li>
          <li>
            <strong>{t("whatsNew.newViews", "New Pitch & List views")}</strong>{" "}
            -{" "}
            {t(
              "whatsNew.newViewsDescription",
              "Switch instantly between Fixture Difficulty, Ownership and Form views on the Pick Team, Points and Transfers pages.",
            )}{" "}
          </li>
          <li>
            <strong>
              {t("whatsNew.scoringBalanceChanges", "Rebalanced bonus points")}
            </strong>{" "}
            -{" "}
            {t(
              "whatsNew.scoringBalanceChangesDescription",
              "We’ve updated the Bonus Points System to give full-backs, goalkeepers and attacking players a slightly better chance of earning bonus points.",
            )}{" "}
          </li>
          <li>
            <strong>{t("whatsNew.rookieLeague", "Rookie League")}</strong> -{" "}
            {t(
              "whatsNew.rookieLeagueDescription",
              "Playing for the first time? You’ll be automatically entered into a brand-new league exclusively for rookie managers, with its own prize.",
            )}{" "}
          </li>
        </ul>
        <p>
          {t(
            "whatsNew.moreDetails",
            "Visit the following page for more details about this season’s changes: ",
          )}
          <Link to="/help/new" target="_blank">
            {t("whatsNew.readMoreLink", "fantasy.premierleague.com/help/new")}
          </Link>
        </p>
      </div>
    </Sheet>
  );
};

export default WhatsNewSheet;
